import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "@/lib/api";
import ProstoHeader from "@/prosto/ProstoHeader";
import ProstoAppRow from "@/prosto/ProstoAppRow";
import LoadError from "@/components/LoadError";
import { apiErrorMessage } from "@/lib/apiResponses";

export default function ProstoCategory() {
  const { name } = useParams();
  const [apps, setApps] = useState(null);
  const [error, setError] = useState(null);
  const [retry, setRetry] = useState(0);
  const cat = decodeURIComponent(name || "");

  useEffect(() => {
    const controller = new AbortController();
    setApps(null);
    setError(null);
    api.apps({ category: cat }, { signal: controller.signal })
      .then((data) => { if (!controller.signal.aborted) setApps(data); })
      .catch((e) => { if (!controller.signal.aborted) setError(apiErrorMessage(e)); });
    return () => controller.abort();
  }, [cat, retry]);

  return (
    <div className="pb-20">
      <ProstoHeader title={cat} back />
      <div className="px-4 pt-2">
        {error ? (
          <LoadError message={error} onRetry={() => setRetry((n) => n + 1)} testId="prosto-category-error" />
        ) : apps === null ? (
          <div className="py-10 text-center text-slate-400">Загрузка…</div>
        ) : apps.length === 0 ? (
          <div className="py-10 text-center text-slate-400">В этой категории пока пусто.</div>
        ) : (
          <div className="divide-y divide-slate-100">
            {apps.map((app) => (
              <ProstoAppRow key={app.id} app={app} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
